import React from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import { Outlet } from "react-router-dom";
import { Box, Container } from "@mui/material";

// Define the NavbarFooterContainer functional component
const NavbarFooterContainer: React.FC = () => {
  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%", // Set the width to 100%
        padding: 0, // Remove padding
        margin: 0, // Remove margin
      }}
    >
      {/* Render the Navbar component */}
      <Navbar />
      {/* Render the Outlet component to display the matched child route */}
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <Outlet />
      </Box>
      {/* Render the Footer component */}
      <Footer />
    </Container>
  );
};

export default NavbarFooterContainer;
